"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axiosJson = axiosJson;
exports.axiosApi = axiosApi;
exports.axiosHelper = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _apiBusy = require("../api-busy/slice/api-busy.helper");

var _lifecycle = require("../lifecycle");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var axios;

function setAxios(value) {
  axios = value;
}

function getAxios() {
  return axios;
}

function ajaxOK(data) {
  (0, _apiBusy.ajaxEnded)();
  return data;
}

function ajaxKO(reason) {
  (0, _apiBusy.ajaxEnded)();
  return Promise.reject(reason);
}
/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "axios"
 *
 * @return {object}           The response data
 */


function axiosJson(url, options) {
  (0, _apiBusy.ajaxStarts)();
  var modifiedOptions = options || {};
  modifiedOptions.url = url;
  return axios.request(modifiedOptions).then(function (response) {
    return response.data;
  }).then(ajaxOK)["catch"](ajaxKO);
}
/**
 * Requests a URL to a DealerSocket API, returns a promise.
 * The bearer access token is added to the headers.
 */


function axiosApi(url, options) {
  var allOptions = options || {};

  var noReleasePoolHeader = allOptions.noReleasePoolHeader,
      modifiedOptions = _objectWithoutProperties(allOptions, ["noReleasePoolHeader"]);

  if (modifiedOptions.method) {
    modifiedOptions.method = modifiedOptions.method.toLowerCase();

    if (modifiedOptions.method !== options.method) {
      // eslint-disable-next-line no-console
      console.error('axios: method value must be lowercase');
    }
  } else {
    modifiedOptions.method = 'get';
  }

  if (modifiedOptions.body) {
    modifiedOptions.data = modifiedOptions.body;
    delete modifiedOptions.body; // eslint-disable-next-line no-console

    console.error("axios: posted data must be in the 'data' property and not in the 'body' property.");
  }

  var headers = modifiedOptions.headers || {};

  var state = _reduxUtils.storeHelper.getState();

  var token = state ? (0, _lifecycle.accessTokenSelector)(state) : undefined;

  if (token) {
    headers.Authorization = "Bearer ".concat(token);
  }

  var releasePool = state ? (0, _lifecycle.releasePoolSelector)(state) : undefined;

  if (releasePool && !noReleasePoolHeader) {
    headers['X-RP_rp'] = releasePool;
  }

  modifiedOptions.headers = headers;
  return axiosJson(url, modifiedOptions);
}

var axiosHelper = {
  axiosApi: axiosApi,
  axiosJson: axiosJson,
  getAxios: getAxios,
  setAxios: setAxios
};
exports.axiosHelper = axiosHelper;